import { ReactIntegration } from '@grafana/faro-react';
import { initializeFaroForApp, senderFaroConfig, getFaroConfig } from '@repo/utils';
import { version } from '../../package.json';
import { env } from './environment-config';

const faroEnvConfig = getFaroConfig(senderFaroConfig, env);

export const faro = initializeFaroForApp({
  name: 'sender-ui',
  version,
  collectorKey: faroEnvConfig.collectorKey,
  appId: faroEnvConfig.appId,
  environment: env,
  sessionTracking: true,
  additionalInstrumentations: [new ReactIntegration()],
});
